import { Alert, Box, CircularProgress, Collapse, Container, Grid, IconButton, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SeguimientoDTO } from "../../types/Seguimiento/SeguimientoDTO";
import { AnunciosData, GetVoidAnunciosData } from "../../types/Anuncio/AnuncioData";
import { FaRegWindowClose } from "react-icons/fa";
import Timeline from "../../componente/Anuncio/TimeLine";
import AnuncioService from "../../services/AnuncioService";
import { themePalette } from "../../config/theme.config";

export const HistorialEstadoPage: React.FC<{}> = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [eventos, setEventos] = useState<Array<SeguimientoDTO>>([]);
    const [anuncio, setAnuncio] = useState<AnunciosData>(GetVoidAnunciosData());
    const [open, setOpen] = useState(true);
    const { id } = useParams<{ id: string }>();
    // function
    const GetHistorial = () => {
        setLoading(true)
        AnuncioService.GetMiAnuncioHistorial(parseInt(id ?? '', 10))
            .then((resp) => {
                if (resp.status === 200) {
                    const ordenado = resp.list_data.sort((a, b) => {
                        const dateA = new Date(a.dtSeguimiento);
                        const dateB = new Date(b.dtSeguimiento);
                        return dateB.getTime() - dateA.getTime(); // Descendente
                    });
                    setEventos(ordenado)
                }
            }).catch((error) => {
                console.error(error);
            }).finally(() => {
                setLoading(false)
            })
    }
    const GetAnuncio = () => {
        AnuncioService.GetMiAnuncio(parseInt(id ?? '', 10))
            .then((resp) => {
                if(resp.status.isSuccessfully){
                    setAnuncio(resp.data || GetVoidAnunciosData());
                }                
            }).catch((error) => {
                console.error(error);
            })
    }
    // Effect
    useEffect(() => {
        GetAnuncio()
        GetHistorial()
    }, []);
    return (
        <Container maxWidth="lg" style={{ padding: '20px', textAlign: 'center', alignContent: 'center', alignItems: 'center', marginTop: 10, border: `1px solid ${themePalette.NAVCOLOR}`, borderTopWidth: '3px', borderRadius: '5px' }}>
            <Box sx={{ display: 'flex' }}>
                <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: `${themePalette.NAVCOLOR}` }}>
                    HISTORIAL ESTADO
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', m: 2 }}>
                <Typography variant="h5" gutterBottom>
                    {anuncio.txTitulo}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', m: 2 }}>
                <Grid container spacing={2} style={{ padding: '10px', textAlign: 'center', alignContent: 'center', alignItems: 'center' }}>
                    {loading ? (
                        <CircularProgress />
                    ) : (
                        <>
                            <Grid item lg={12} >
                                <Collapse in={open}>
                                    <Alert
                                        severity="warning"
                                        action={
                                            <IconButton
                                                aria-label="close"
                                                color="inherit"
                                                size="small"
                                                onClick={() => {
                                                    setOpen(false);
                                                }}
                                            >
                                                <FaRegWindowClose fontSize="inherit" />
                                            </IconButton>
                                        }
                                        sx={{ mb: 2 }}
                                    >
                                        Al dar clic en las tarjetas rojas podrá leer la retroalimentación.
                                    </Alert>
                                </Collapse>
                            </Grid>
                            <Grid item lg={12}>
                                <Timeline eventos={eventos} edit />
                            </Grid>
                        </>
                    )}
                </Grid>
            </Box>
        </Container>
    );
}